module.exports = __webpack_public_path__ + "static/farmers_fulfillment-ced0df43054249862081ac286bebd81a.png";